/* eslint-disable camelcase */
import axios from 'axios'
import { useCallback, useEffect, useState } from 'react'
import { config } from '../../../config'

interface UseFetchJson {
  loading: boolean
  error: boolean
  result: any
}

export const useFetchJson = ({ url }: { url: string | null }): UseFetchJson => {
  const [result, setResult] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const fetchJson = useCallback(async ({ path }: { path: string }) => {
    try {
      let { data }: any = await axios.get(
        `${config.api.balance.d2}/v3/download${path}`
      )

      if (typeof data === 'string') {
        data = JSON.parse(data)
      }

      setResult(data)
      setError(false)
      setLoading(false)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
      setResult(null)
      setError(true)
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (url) {
      setLoading(true)
      fetchJson({ path: url })
    }
  }, [url, fetchJson])

  return {
    result,
    error,
    loading
  }
}
